import React from 'react'
import { observer } from 'mobx-react'
import { observable, computed, transaction } from 'mobx'
import { HelpBlock, FormGroup } from 'react-bootstrap'
import SugestingInput from './suggesting_input'

const SelectWithSuggestions = ({
  attr, labelattr, valueattr, label, record, validationSuccess, disabled,
  optionsrecord, optionsattr, errors, onChange, noInputAddon, ...rest
}) => {
  const options = optionsrecord.get(optionsattr || attr)
  const errorText = errors ? errors.get(attr) : undefined
  const validationState = errorText ? 'error' : (validationSuccess ? 'success' : null)
  let value = record.get(attr)
  valueattr = valueattr || 'id'
  labelattr = labelattr || 'text'

  if (!options || options.length === 0) {
    return null
  }

  if (value && !isNaN(value)) {
    value = parseInt(value)
  }
  let valueText = value ? options.find((i) => {
    return i[valueattr] && i[valueattr] === value
  }) : ''
  valueText = valueText && valueText[labelattr]

  function _isMatching (opt, val) {
    const matchVal = opt[labelattr] && opt[labelattr].toLowerCase().indexOf(val.toLowerCase()) != -1
    return matchVal
  }
  const info = observable({
    inputval: valueText,
    keyPressed: false,
    get availableOptions () {
      return _getUniqueOpts().sort((a, b) => {
        return a[labelattr].localeCompare(b[labelattr])
      })
    }
  })
  function _getUniqueOpts () {
    return info.inputval ? options.filter((i) => {
      return _isMatching(i, info.inputval)
    }) : []
  }
  function onSelect (opt) {
    onChange(attr, opt[valueattr])
  }

  return (
    <FormGroup validationState={validationState}>
      <fieldset disabled={disabled}>
        {label && <label className='control-label'>{label}</label>}
        <div className='clearfix'>
          <SugestingInput noInputAddon={noInputAddon} info={info} options={options}
            onSelect={onSelect} isMatching={_isMatching}
            placeholder={'start writing to get suggesions ...'}
            labelattr={labelattr} valueattr={valueattr} />
        </div>
        {errorText ? <HelpBlock>{errorText}</HelpBlock> : null}
      </fieldset>
    </FormGroup>
  )
}
export default observer(SelectWithSuggestions)
